import { replaceUrlForLocal } from "../../../environment";
import { picturesServices } from "../pictures/picturesServices";
import { Api } from "../axios-config";

export interface IBanner {
    _id: string;
    UserId: string;
    Name: string;
    order: number;
    DeskPictureId?: string;
    MobilePictureId?: string;
    DeskPictureUrl?: string;
    MobilePictureUrl?: string;
}

export interface IListBanners {
    data: IBanner[];
}

const getAllBanners = async (): Promise<IListBanners | Error> => {
    try {
        const { data } = await Api.get("/banners");
        
        if (data) {
            const adaptedData = await Promise.all(data.map(async (banner: any) => {
                let deskUrl = banner.DeskPictureUrl || banner.deskPictureUrl || '';
                let mobileUrl = banner.MobilePictureUrl || banner.mobilePictureUrl || '';

                // Verifica se a URL é inválida (vazia ou começou com "undefined" vindo da API)
                const isDeskInvalid = !deskUrl || deskUrl.toString().startsWith('undefined');
                const isMobileInvalid = !mobileUrl || mobileUrl.toString().startsWith('undefined');

                // Fallback: busca por ID se a URL for inválida
                if (isDeskInvalid && (banner.DeskPictureId || banner.deskPictureId)) {
                    const id = banner.DeskPictureId || banner.deskPictureId;
                    const pic = await picturesServices.getPictureByID(id);
                    if (!(pic instanceof Error)) {
                        deskUrl = pic.key; // Usar a key é mais seguro que a URL que pode estar errada
                    }
                }

                if (isMobileInvalid && (banner.MobilePictureId || banner.mobilePictureId)) {
                    const id = banner.MobilePictureId || banner.mobilePictureId;
                    const pic = await picturesServices.getPictureByID(id);
                    if (!(pic instanceof Error)) {
                        mobileUrl = pic.key;
                    }
                }

                return {
                    ...banner,
                    DeskPictureUrl: replaceUrlForLocal(deskUrl),
                    MobilePictureUrl: replaceUrlForLocal(mobileUrl),
                };
            }));
            return { data: adaptedData };
        } else {
            return new Error('Erro ao listar banners');
        }
    } catch (error) {
        return new Error(`Erro ao listar banners: ${error}`);
    }
};

const getBannerById = async (id: string): Promise<IBanner | Error> => {
    try {
        const { data } = await Api.get(`/banners/${id}`);
        return data;
    } catch (error) {
        return new Error(`Erro ao buscar banner por id: ${error}`);
    }
};

export const BannerServices = {
    getAllBanners,
    getBannerById,
};
